<div class="modal fade" id="kt_modal_invoice_detail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header py-2 px-3 border-bottom">
        <h5 class="fw-bold mb-0">Invoice Form</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0" *ngIf="selectedInvoice">
        <form id="invoiceForm" [formGroup]="invoiceForm" (ngSubmit)="onSave()" novalidate>

          <!-- ===== SCROLLABLE AREA (action bar + allocation tables + 3-col layout) ===== -->
          <div class="inv-scrollable-area">

          <!-- Top Action Bar -->
          <div class="inv-action-bar d-flex align-items-center justify-content-between px-2 py-1 border-bottom">
            <div class="d-flex align-items-center gap-1">
              <input type="text" class="form-control form-control-sm inv-stock-input" placeholder="Enter Stock Number"
                formControlName="stockNumberSearch">
              <button type="button" class="btn btn-sm btn-primary inv-btn-action" (click)="searchInvoiceByStockNumber()"
                [disabled]="isSearchingInvoice">
                <span *ngIf="!isSearchingInvoice">SEARCH</span>
                <span *ngIf="isSearchingInvoice"><span class="spinner-border spinner-border-sm me-1"></span>...</span>
              </button>
              <button type="submit" class="btn btn-sm btn-success inv-btn-action" [disabled]="isLoading">
                <span *ngIf="!isLoading">SAVE</span>
                <span *ngIf="isLoading"><span class="spinner-border spinner-border-sm me-1"></span>...</span>
              </button>
              <button type="button" class="btn btn-sm btn-info inv-btn-action allocation-trigger"
                (click)="openAllocationPage()">Allocation</button>
              <button type="button" class="btn btn-sm btn-secondary inv-btn-action" (click)="cancelInvoice()"
                [disabled]="isLoading">Cancel</button>
              <button type="button" class="btn btn-sm inv-btn-action inv-btn-custom-cl">Custom CL</button>
            </div>
            <div class="d-flex align-items-center gap-1">
              <button type="button" class="btn btn-sm btn-warning inv-btn-action" style="text-transform:capitalize;">
                {{selectedInvoice?.status || 'Pending'}} Invoice
              </button>
              <button type="button" class="btn btn-sm btn-primary inv-btn-action">SHIP ID</button>
              <button type="button" class="btn btn-sm btn-dark inv-btn-action">BANKS</button>
              <button type="button" class="btn btn-sm btn-info inv-btn-action">CLIENTS</button>
            </div>
          </div>


          <!-- Allocation / Approval Table (shown when allocations exist) -->
          <div class="px-2 pt-1" >
            <table class="table table-bordered table-sm inv-table mb-1" *ngIf="selectedInvoice.status == 'approved' ">
              <thead class="table-light">
                <tr>
                  <th>Approved Date</th>
                  <th>Invoice Date</th>
                  <th>Invoice Amount</th>
                  <th>Approved By</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{selectedInvoice?.created_at | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                  <td>{{selectedInvoice?.invoice_date | date:'yyyy-MM-dd'}}</td>
                  <td>{{selectedInvoice?.invoice_amount | number}}</td>
                  <td>{{selectedInvoice?.approved_by?.name}}</td>
                </tr>
              </tbody>
            </table>
            <p class="inv-note mb-1" *ngIf="hasAllocations()">
              <strong class="text-danger">Note:</strong> You cannot change the customer as this invoice already allocated.
            </p>
            <table class="table table-bordered table-sm inv-table mb-1" *ngIf="hasAllocations()">
              <thead class="table-light">
                <tr>
                  <th>Allocation Date</th>
                  <th>Allocated Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let alloc of selectedInvoice?.allocations">
                  <td>{{alloc.created_at | date:'yyyy-MM-dd'}}</td>
                  <td>{{alloc.amount_in_usd}} USD</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Main 3-Column Layout -->
          <div class="d-flex inv-main-content">

            <!-- ===== LEFT COLUMN: Invoice / Vehicle Details ===== -->
            <div class="inv-left-col border-end p-2">

              <div class="inv-field-row">
                <span class="inv-label">Invoice No.</span>
                <span class="inv-value-text">{{selectedInvoice?.invoice_number}}</span>
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Stock Number#</span>
                <input type="text" class="form-control form-control-sm inv-input" formControlName="stockNumber">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Invoice Date</span>
                <div class="d-flex align-items-center gap-1 flex-fill">
                  <input type="text" class="form-control form-control-sm inv-input" formControlName="invoiceDate">
                  <button type="button" class="btn btn-danger btn-sm inv-clear-btn" (click)="clearInvoiceDate()" title="Clear date">×</button>
                </div>
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Chassis No.</span>
                <input type="text" class="form-control form-control-sm inv-input" formControlName="chassisNo">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">HS Code</span>
                <input type="text" class="form-control form-control-sm inv-input" formControlName="hsCode">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Engine Number</span>
                <input type="text" class="form-control form-control-sm inv-input" formControlName="engineNumber">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Engine Type</span>
                <input type="text" class="form-control form-control-sm inv-input" formControlName="engineType">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Pay Terms</span>
                <select class="form-select form-select-sm inv-input" formControlName="payTerms">
                  <option value="">--Select--</option>
                  <option value="DA AT SIGHT">DA AT SIGHT</option>
                  <option value="TT">TT</option>
                  <option value="LC">LC</option>
                  <option value="CAD">CAD</option>
                </select>
              </div>

              <!-- Cost / Insurance / Freight aligned right -->
              <div class="inv-field-row-right">
                <span class="inv-label-inline">Cost</span>
                <input type="text" class="form-control form-control-sm inv-input-sm text-end" formControlName="cost">
              </div>
              <div class="inv-field-row-right">
                <span class="inv-label-inline">Insurance</span>
                <input type="text" class="form-control form-control-sm inv-input-sm text-end" formControlName="insurance">
              </div>
              <div class="inv-field-row-right">
                <span class="inv-label-inline">Freight</span>
                <input type="text" class="form-control form-control-sm inv-input-sm text-end" formControlName="freight">
              </div>

              <!-- C&F / Currency / Amount row -->
              <div class="d-flex align-items-center gap-1 mb-1">
                <select class="form-select form-select-sm inv-select-tiny" formControlName="orderType">
                  <option value="C&F">C&F</option>
                  <option value="FOB">FOB</option>
                  <option value="CIF">CIF</option>
                </select>
                <select class="form-select form-select-sm inv-select-tiny" formControlName="currency">
                  <option value="USD">USD</option>
                  <option value="JPY">JPY</option>
                </select>
                <span class="inv-label-inline" style="white-space:nowrap">Amount $</span>
                <input type="text" class="form-control form-control-sm text-end flex-fill" formControlName="cifAmount">
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Bank</span>
                <select class="form-select form-select-sm inv-input" formControlName="bank">
                  <option value="">Select Bank</option>
                  <option *ngFor="let bank of banks" [value]="bank._id">{{bank.name}}</option>
                </select>
              </div>

              <div class="inv-field-row">
                <span class="inv-label">Payment Due Date</span>
                <input type="date" class="form-control form-control-sm inv-input" formControlName="paymentDueDate">
              </div>

            </div>
            <!-- END LEFT COLUMN -->

            <!-- ===== MIDDLE COLUMN: Consignee + Notify Party ===== -->
            <div class="inv-middle-col border-end p-2">

              <!-- Consignee header + Choose Consignee button -->
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="inv-section-label">Consignee</span>
                <div class="position-relative flex-fill mx-1">
                  <input type="text" class="form-control form-control-sm" placeholder="Search consignee..."
                    [(ngModel)]="userSearchTerm" [ngModelOptions]="{standalone: true}"
                    (input)="onUserSearchInput($event)" (focus)="onUserInputFocus()" (blur)="onUserInputBlur()"
                    [disabled]="hasAllocations()" autocomplete="off" />
                  <div *ngIf="isUserSearching" class="position-absolute top-50 end-0 translate-middle-y me-2">
                    <span class="spinner-border spinner-border-sm text-primary"></span>
                  </div>
                  <!-- Dropdown Results -->
                  <div *ngIf="showUserDropdown"
                    class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border"
                    style="z-index:1050;max-height:200px;overflow-y:auto;">
                    <div *ngIf="userSearchResults.length === 0 && !isUserSearching"
                      class="dropdown-item-text text-muted text-center py-2">No users found</div>
                    <a *ngFor="let user of userSearchResults" href="javascript:void(0)"
                      class="dropdown-item py-1" (click)="selectUser(user)">
                      <span class="fw-bold inv-table-text">{{getUserDisplayName(user)}}</span>
                    </a>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary inv-btn-choose"
                  [disabled]="hasAllocations()">Choose Consignee</button>
              </div>

              <!-- Consignee Info Display Box -->
              <div class="inv-consignee-box mb-1">
                <div class="inv-consignee-row">
                  {{invoiceForm.get('consignee')?.value}}
                  <span *ngIf="invoiceForm.get('consignee')?.value">
                    [{{invoiceForm.get('consignee')?.value}}, {{invoiceForm.get('consigneeCity')?.value}}]
                  </span>
                </div>
                <div class="inv-consignee-row fw-bold">{{invoiceForm.get('consignee')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneeName')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneeEmail')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneePhone')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneeAddress')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneeCity')?.value}}</div>
                <div class="inv-consignee-row">{{invoiceForm.get('consigneeCountry')?.value}}</div>
              </div>

              <!-- Notify Party -->
              <div class="d-flex align-items-center gap-2 mb-1">
                <span class="inv-section-label">Notify Party</span>
                <input type="checkbox" id="sameAsConsignee" class="inv-checkbox"
                  formControlName="sameAsConsignee">
                <label for="sameAsConsignee" class="inv-checkbox-label">Same As Consignee</label>
              </div>

              <input type="text" class="form-control form-control-sm mb-1" placeholder="Notify Party Company"
                formControlName="notifyPartyCompany">
              <input type="text" class="form-control form-control-sm mb-1" placeholder="Notify Party Name"
                formControlName="notifyPartyName">
              <input type="email" class="form-control form-control-sm mb-1" placeholder="Email"
                formControlName="notifyPartyEmail">
              <input type="text" class="form-control form-control-sm mb-1" placeholder="Telephone"
                formControlName="notifyPartyPhone">
              <input type="text" class="form-control form-control-sm mb-1" placeholder="Address"
                formControlName="notifyPartyAddress">
              <input type="text" class="form-control form-control-sm mb-1" placeholder="City"
                formControlName="notifyPartyCity">
              <input type="text" class="form-control form-control-sm mb-1" placeholder="Country"
                formControlName="notifyPartyCountry">

            </div>
            <!-- END MIDDLE COLUMN -->

            <!-- ===== RIGHT COLUMN: Financial + Notes ===== -->
            <div class="inv-right-col p-2">

              <!-- Total Cost + Profit/Loss -->
              <div class="d-flex align-items-center gap-1 mb-1">
                <span class="inv-label-inline">Total Cost</span>
                <input type="text" class="form-control form-control-sm inv-input-cost" formControlName="totalCost">
                <span class="inv-label-inline">Profit/Loss</span>
                <input type="text" class="form-control form-control-sm flex-fill" formControlName="salesPrice"
                  placeholder="Profit/Loss">
              </div>

              <!-- Sales Price -->
              <div class="d-flex align-items-center gap-1 mb-1">
                <span class="inv-label-right">Sales Price</span>
                <input type="text" class="form-control form-control-sm flex-fill" formControlName="salesPrice">
              </div>

              <!-- Courier Name + Courier No -->
              <div class="d-flex align-items-center gap-1 mb-1">
                <span class="inv-label-inline">Courier Name</span>
                <select class="form-select form-select-sm inv-select-courier" formControlName="courierName">
                  <option value="">--Select--</option>
                </select>
                <span class="inv-label-inline">Courier No.</span>
                <input type="text" class="form-control form-control-sm flex-fill" formControlName="courierNo">
              </div>

              <!-- Courier Date -->
              <div class="d-flex align-items-center gap-1 mb-1">
                <span class="inv-label-right">Courier Date</span>
                <input type="date" class="form-control form-control-sm flex-fill" formControlName="courierDate">
              </div>

              <!-- Notes -->
              <div class="mb-1">
                <label class="inv-section-label d-block mb-0">Note :</label>
                <textarea class="form-control form-control-sm inv-textarea" rows="5"
                  formControlName="notes"></textarea>
              </div>

              <!-- Admin Comments -->
              <div class="mb-1">
                <label class="inv-section-label d-block mb-0">Admin Comment :</label>
                <textarea class="form-control form-control-sm inv-textarea" rows="5"
                  formControlName="adminComments"></textarea>
              </div>

            </div>
            <!-- END RIGHT COLUMN -->

          </div>
          <!-- END MAIN 3-COLUMN LAYOUT -->

          <!-- ===== BOTTOM SHIPPING BAR ===== -->
          <div class="inv-ship-bar">

            <!-- Row 1: Ship ID | Ship Name | Carrier Name | Voyage Number | Sailing Date -->
            <div class="inv-ship-row">

              <!-- Ship ID (searchable dropdown) -->
              <div class="inv-ship-cell position-relative">
                <label class="inv-ship-label">Ship ID</label>
                <input type="text" class="form-control form-control-sm inv-ship-input"
                  [(ngModel)]="shipIdSearchTerm" [ngModelOptions]="{standalone: true}"
                  (input)="onShipIdInput($event)"
                  (focus)="onShipIdFocus()"
                  (blur)="onShipIdBlur()"
                  autocomplete="off"
                  placeholder="Click to search..." />
                <div *ngIf="isShipSearching && showShipIdDropdown"
                  class="position-absolute end-0 me-1" style="top:50%;transform:translateY(-50%)">
                  <span class="spinner-border text-primary" style="width:12px;height:12px;border-width:2px"></span>
                </div>
                <div *ngIf="showShipIdDropdown"
                  class="dropdown-menu show shadow border inv-ship-dropdown-up">
                  <div *ngIf="shipSearchResults.length === 0 && !isShipSearching"
                    class="dropdown-item-text text-muted text-center py-2" style="font-size:0.75rem">
                    No ships found
                  </div>
                  <a *ngFor="let ship of shipSearchResults" href="javascript:void(0)"
                    class="dropdown-item py-2" (click)="selectShip(ship)">
                    <div class="fw-semibold" style="font-size:0.78rem">{{ship.ship_id || ship._id}}</div>
                    <div class="text-muted" style="font-size:0.72rem">{{ship.name}} — {{ship.company}} ({{ship.voyage_no}})</div>
                    <div class="text-muted" style="font-size:0.72rem">{{ship.sailing_port}} → {{ship.destination_port}}</div>
                  </a>
                </div>
              </div>

              <!-- Ship Name (searchable) -->
              <div class="inv-ship-cell position-relative">
                <label class="inv-ship-label">Ship Name</label>
                <input type="text" class="form-control form-control-sm inv-ship-input"
                  [(ngModel)]="shipSearchTerm" [ngModelOptions]="{standalone: true}"
                  (input)="onShipSearchInput($event)" (focus)="onShipInputFocus()" (blur)="onShipInputBlur()"
                  autocomplete="off" placeholder="Search ship..." />
                <div *ngIf="isShipSearching && showShipDropdown"
                  class="position-absolute end-0 me-1" style="top:50%;transform:translateY(-50%)">
                  <span class="spinner-border text-primary" style="width:12px;height:12px;border-width:2px"></span>
                </div>
                <div *ngIf="showShipDropdown"
                  class="dropdown-menu show shadow border inv-ship-dropdown-up">
                  <div *ngIf="shipSearchResults.length === 0 && !isShipSearching"
                    class="dropdown-item-text text-muted text-center py-2" style="font-size:0.75rem">No ships found</div>
                  <a *ngFor="let ship of shipSearchResults" href="javascript:void(0)"
                    class="dropdown-item py-2" (click)="selectShip(ship)">
                    <div class="fw-semibold" style="font-size:0.78rem">{{getShipDisplayName(ship)}}</div>
                    <div class="text-muted" style="font-size:0.72rem">{{ship.sailing_port}} → {{ship.destination_port}}</div>
                  </a>
                </div>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Carrier Name</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="carrierName" readonly>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Voyage Number</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="voyageNumber" readonly>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Sailing Date</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="sailingDate" readonly>
              </div>

            </div>
            <!-- END ROW 1 -->

            <!-- Row 2: Sailing Port | Destination Port | Country | Arrival Date -->
            <div class="inv-ship-row">

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Sailing Port</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="sailingPort" readonly>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Destination Port</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="destinationPort" readonly>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Country</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="destinationCountry" readonly>
              </div>

              <div class="inv-ship-cell">
                <label class="inv-ship-label">Arrival Date</label>
                <input type="text" class="form-control form-control-sm inv-ship-input" formControlName="arrivalDate" readonly>
              </div>

            </div>
            <!-- END ROW 2 -->

          </div>
          <!-- END BOTTOM SHIPPING BAR -->

          </div>
          <!-- END SCROLLABLE AREA -->

        </form>
      </div>

    </div>
  </div>
</div>
